var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.342,
    height: 60,
    viewBox: "0 0 60.342 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9084",
    "data-name": "Group 9084",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M4178.94,261.412c0,.741,0,1.431,0,2.125,0,1.207-.009,2.414.019,3.62a3.739,3.739,0,0,0,2.774,3.479,3.817,3.817,0,0,0,4.111-1.384,3.905,3.905,0,0,0,.757-2.374c0-1.752,0-3.5.006-5.253,0-.058,0-.112.006-.188h29.238v.881c0,1.579-.017,3.162.012,4.74a3.83,3.83,0,0,0,7.126,1.846,3.572,3.572,0,0,0,.516-1.958c-.017-.914-.007-1.828-.007-2.739v-2.8h1.094c1.619,0,3.238,0,4.851.011a1.863,1.863,0,0,1,1.948,1.987q0,6.14-.007,12.277v22.184q0,7.593.007,15.189a6.869,6.869,0,0,1-.026.853,1.855,1.855,0,0,1-1.858,1.6c-1.791,0-3.58,0-5.37,0h-22.615q-4.211,0-8.423,0-7.411,0-14.818,0c-1.764,0-3.525-.032-5.283.011a2.011,2.011,0,0,1-1.948-1.958c.029-4.585.014-9.174.014-13.762q.007-9.322,0-18.643.007-4.037,0-8.079,0-4.856,0-9.708a1.838,1.838,0,0,1,1.957-1.966c1.866,0,3.729,0,5.6,0Zm22.226,51.613h.425q4.142.006,8.285.014c1.881,0,3.767,0,5.65,0,2.125,0,4.245-.014,6.369-.014,1.721,0,3.445.014,5.17.014a1.711,1.711,0,0,0,1.858-1.864v-7.566q0-7.056-.007-14.105,0-6.883.007-13.762a1.739,1.739,0,0,0-1.91-1.911c-1.874,0-3.752.011-5.624.007q-5.553-.006-11.1-.018c-1.867,0-3.733.018-5.6.018q-6.472-.006-12.959-.018c-1.6,0-3.2.018-4.794.018q-5.785.005-11.57,0a1.708,1.708,0,0,0-1.819,1.821c0,1.836,0,3.671,0,5.51q0,7.078,0,14.159,0,7.913.009,15.818a1.681,1.681,0,0,0,1.843,1.872c2.815.007,5.634,0,8.452,0q3.854.006,7.708.014c1.378,0,2.76-.011,4.141-.014Z",
    transform: "translate(-4171.052 -255.533)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M4183.879,266.724c0-1.51,0-3.024,0-4.534a2.231,2.231,0,0,1,1.185-2.1,2.16,2.16,0,0,1,2.4.123,2.125,2.125,0,0,1,.959,1.818q0,3.609-.015,7.219c0,.748.034,1.5-.039,2.247a2.22,2.22,0,0,1-2.1,1.886,2.261,2.261,0,0,1-2.236-1.481,2.952,2.952,0,0,1-.135-.809c-.012-1.456,0-2.912,0-4.368Z",
    transform: "translate(-4137.522 -259.785)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M4178.188,266.473c0,1.626.023,3.255-.013,4.881a2.212,2.212,0,0,1-1.785,1.969,2.276,2.276,0,0,1-2.428-1.095,2.408,2.408,0,0,1-.294-1.2c0-2.959,0-5.914,0-8.874a2.275,2.275,0,0,1,2.156-2.356,2.235,2.235,0,0,1,2.371,2.168c.011,1.5,0,3.006,0,4.509Z",
    transform: "translate(-4164.226 -259.777)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M4181.532,275.913c0-1.185-.019-2.37.007-3.552.022-1.268.532-1.879,1.754-1.9q3.732-.076,7.459,0a1.643,1.643,0,0,1,1.732,1.828q.038,3.61,0,7.223a1.726,1.726,0,0,1-1.838,1.886c-2.407.047-4.816.043-7.225,0a1.719,1.719,0,0,1-1.883-1.937C4181.514,278.28,4181.532,277.094,4181.532,275.913Z",
    transform: "translate(-4143.677 -231.995)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M4174.06,272.054c0-1.145-.02-2.287,0-3.432.025-1.232.583-1.886,1.76-1.9q3.731-.065,7.454,0a1.62,1.62,0,0,1,1.723,1.824q.034,3.6,0,7.215a1.678,1.678,0,0,1-1.812,1.879c-2.444.051-4.894.054-7.337-.007-1.193-.025-1.763-.7-1.783-1.908S4174.06,273.275,4174.06,272.054Z",
    transform: "translate(-4163.205 -241.755)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M4183.257,266.692c1.147,0,2.291-.018,3.434,0,1.391.029,2.042.65,2.056,2.013q.037,3.485,0,6.977a1.756,1.756,0,0,1-1.89,1.955q-3.606.065-7.217,0c-1.251-.026-1.829-.683-1.839-1.973q-.034-3.545,0-7.1a1.627,1.627,0,0,1,1.795-1.864c1.219-.043,2.443-.007,3.661-.007Z",
    transform: "translate(-4153.453 -241.755)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M4174.061,275.813c0-1.185-.021-2.37.006-3.552a1.633,1.633,0,0,1,1.748-1.807q3.729-.07,7.465,0A1.611,1.611,0,0,1,4185,272.28q.038,3.615,0,7.226a1.7,1.7,0,0,1-1.81,1.89q-3.669.076-7.339,0a1.7,1.7,0,0,1-1.786-1.911C4174.042,278.259,4174.061,277.034,4174.061,275.813Z",
    transform: "translate(-4163.213 -231.996)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M4188.75,275.873c0,1.185.019,2.37,0,3.556-.022,1.272-.613,1.948-1.852,1.973-2.407.047-4.815.043-7.221,0a1.733,1.733,0,0,1-1.87-1.958c-.013-2.37-.018-4.737,0-7.107a1.655,1.655,0,0,1,1.79-1.886q3.671-.07,7.341,0c1.215.022,1.777.65,1.808,1.868C4188.771,273.507,4188.75,274.691,4188.75,275.873Z",
    transform: "translate(-4153.429 -231.998)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M4187.064,266.693c1.145,0,2.29-.022,3.43.007,1.332.033,1.983.654,1.992,1.948q.04,3.55,0,7.1a1.715,1.715,0,0,1-1.828,1.89q-3.662.076-7.336,0c-1.189-.025-1.766-.687-1.781-1.9q-.034-3.609,0-7.215a1.6,1.6,0,0,1,1.735-1.8c1.261-.051,2.523-.014,3.785-.014Zm3.237,2.19h-6.552v6.554h6.552Z",
    transform: "translate(-4143.676 -241.756)",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9c39c3fd50e060308cbd98d68f86bf42.svg";
export { ForwardRef as ReactComponent };